module.exports = __webpack_public_path__ + "static/media/medprotec.4d47c6f0.png";